import { AppBar, Box, Container } from '@mui/material'
import { SippLogo } from '../../components/icons'

import { Outlet, useNavigate } from 'react-router'


export const VerifyLayout = () =>{
  const navigate = useNavigate()

  return (
    <Container maxWidth="lg" sx={{background: 'white'}} >
      <AppBar
        elevation={0}
        position="relative"
        sx={{
          display: 'relative',
          background: { xs: 'rgba(255, 255, 255, 0.2)', md: 'rgba(255, 255, 255, 1)' },
          p: 1,
        }}
      >
        <SippLogo sx={{ fontSize: '3rem', cursor: 'pointer' }} onClick={() => navigate('/')} />
      </AppBar>
      <Outlet/>

    </Container>
  )
}